<template>
  <v-main>
    <v-container fluid>
      <br />
      <v-row justify="start">
        <v-col>
          <backbutton></backbutton>
          <h1
            class="dj-page-title dj-page-title--inline"
            v-text="'Job of Modules'"
          ></h1>
          <v-btn
            class="mx-2 mb-2"
            :loading="isSaving"
            :disabled="isSaving"
            small
            color="primary"
            @click="save"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12" v-if="module_id">
          <v-card elevation="6">
            <v-simple-table
              fixed-header
              :height="`${moduleJobs.length ? '660px' : ''}`"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="min-width: 70px" class="text-left">Sr No</th>
                    <th style="min-width: 300px" class="text-left">Name</th>
                    <th style="min-width: 300px" class="text-left">
                      Workshop Name
                    </th>
                    <th style="min-width: 140px" class="text-left">
                      Estimate Start Date
                    </th>
                    <th style="min-width: 140px" class="text-left">
                      Estimate End Date
                    </th>
                    <th style="min-width: 130px" class="text-left">
                      Actual Start Date
                    </th>
                    <th style="min-width: 130px" class="text-left">
                      Actual End Date
                    </th>
                    <th style="min-width: 130px" class="text-left">Qty</th>
                    <th style="min-width: 130px" class="text-left">Dry Dock</th>
                    <th style="min-width: 130px" class="text-left">
                      Estimate Cost
                    </th>
                    <th style="min-width: 130px" class="text-left">
                      Actual Cost
                    </th>
                    <th style="min-width: 130px" class="text-left">Remark</th>
                    <th style="min-width: 130px" class="text-left">Status</th>
                    <th style="min-width: 130px" class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(moduleJob, i) in moduleJobs"
                    :key="`moduleJob${i}`"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.name"
                          outlined
                          dense
                          label="Name"
                          hide-details="auto"
                          :error-messages="
                            moduleJob.name == ''
                              ? 'this name field is required'
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.workshop_name"
                          outlined
                          dense
                          label="Workshop Name"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-menu
                        v-model="moduleJob.estimate_start_date_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Select Estimate Start Date"
                            v-model="moduleJob.estimate_start_date"
                            :id="`estimate_start_date${i}`"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="
                              moduleJob.estimate_start_date == ''
                                ? 'this estimate start date field is required'
                                : ''
                            "
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          :id="`estimate_start_date${i}`"
                          v-model="moduleJob.estimate_start_date"
                          @change="moduleJob.estimate_start_date_menu = false"
                          :min="nowDate"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                    <td>
                      <v-menu
                        v-model="moduleJob.estimate_end_date_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Select Estimate End Date"
                            v-model="moduleJob.estimate_end_date"
                            :id="`estimate_end_date${i}`"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="
                              moduleJob.estimate_end_date == ''
                                ? 'this estimate end date field is required'
                                : ''
                            "
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          :id="`estimate_end_date${i}`"
                          v-model="moduleJob.estimate_end_date"
                          @change="moduleJob.estimate_end_date_menu = false"
                          :min="moduleJob.estimate_start_date"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                    <td>
                      <v-menu
                        v-model="moduleJob.actual_start_date_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Select Actual Start Date & Time"
                            v-model="moduleJob.actual_start_date"
                            :id="`actual_start_date${i}`"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          :id="`actual_start_date${i}`"
                          v-model="moduleJob.actual_start_date"
                          @change="moduleJob.actual_start_date_menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                    <td>
                      <v-menu
                        v-model="moduleJob.actual_end_date_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Select Actual End Date"
                            v-model="moduleJob.actual_end_date"
                            :id="`actual_end_date${i}`"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          :id="`actual_end_date${i}`"
                          v-model="moduleJob.actual_end_date"
                          @change="moduleJob.actual_end_date_menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.qty"
                          outlined
                          dense
                          label="Qty"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.dry_dock"
                          outlined
                          dense
                          label="Dry Dock"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.estimate_cost"
                          outlined
                          dense
                          label="Estimate Cost"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.actual_cost"
                          outlined
                          dense
                          label="Actual Cost"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="moduleJob.remark"
                          outlined
                          dense
                          label="Remark"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-select
                          v-model="moduleJob.status"
                          :items="statusItems"
                          chips
                          item-color="red"
                          label="Status"
                          class="mt-2"
                          dense
                        >
                        </v-select>
                      </v-col>
                    </td>
                    <td class="text-right">
                      <div class="text-center">
                        <v-tooltip bottom v-if="moduleJob.id">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="primary"
                              icon
                              @click="showModuleJobTimeline(moduleJob)"
                            >
                              <v-icon>mdi-chart-timeline</v-icon>
                            </v-btn>
                          </template>
                          <span>Timeline</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="!moduleJob.id">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="primary"
                              icon
                              @click="deleteModuleJob(moduleJob)"
                            >
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="primary"
                              icon
                              @click="delete_data(moduleJob.id)"
                            >
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="module_id">
                    <td colspan="16">
                      <v-btn
                        outlined
                        block
                        color="primary"
                        @click="addEmptyModuleJob()"
                      >
                        Add New Row
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Module Job Timeline Pop UP  -->
      <v-dialog v-model="show_details" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>
                {{ moduleJobDetails.name + " Timeline" }}
              </h2>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_details = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-row>
              <v-simple-table fixed-header height="150px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        style="min-width: 120px"
                        v-for="(date, d) in moduleJobDetails.dateRange"
                        :key="`date${d}`"
                      >
                        {{ date.date }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        v-for="(date, d) in moduleJobDetails.dateRange"
                        :key="`date${d}`"
                        :style="`background-color: ${date.color}; height: 25px`"
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn text class="mr-2" @click="show_details = false"
                >Close
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Job Timeline Pop UP -->
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
import moment from "moment";
export default {
  components: { backbutton },
  name: "ModuleJobsPage",
  data() {
    return {
      module_id: "",
      moduleItems: [],
      moduleJobs: [],
      moduleJobDetails: [],
      statusItems: [
        { id: "0", text: "Working on it", value: 0 },
        { id: "1", text: "Stuck", value: 1 },
        { id: "2", text: "Done", value: 2 },
      ],
      isLoading: false,
      isSaving: false,
      show_details: false,
      nowDate: new Date().toISOString().slice(0, 10),
    };
  },
  mounted() {
    this.module_id = this.$route.query.module_id;
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let moduleJobs = await axios.get(
        `/modules/${this.module_id}/module_jobs`
      );
      this.moduleJobs = moduleJobs.data.data;
      this.count = moduleJobs.data.count;
      this.isLoading = false;
    },
    addEmptyModuleJob() {
      this.moduleJobs.push({
        module_id: this.module_id,
        site_id: this.site.id,
        name: "",
        estimate_start_date: "",
        estimate_end_date: "",
        status: 0,
      });
    },
    deleteModuleJob(moduleJob) {
      this.moduleJobs = this.moduleJobs.filter((ar) => ar != moduleJob);
    },
    async save() {
      if (this.moduleJobs.length > 0) {
        this.isSaving = true;
        let payload = {
          datas: this.moduleJobs,
        };
        let response = await axios.post(
          `/modules/${this.module_id}/module_jobs_multiple`,
          payload
        );
        this.moduleJobs = response.data.data;
        this.isSaving = false;
      }
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=module_jobs`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
    showModuleJobTimeline(moduleJob) {
      this.show_details = true;
      if (moduleJob) {
        // If Module Job
        this.moduleJobDetails = moduleJob;
        // Make a Blank array of Estimate Start & End Date
        let array = [
          this.moduleJobDetails.estimate_start_date,
          this.moduleJobDetails.estimate_end_date,
        ];

        if (this.moduleJobDetails.actual_start_date) {
          // If Actual star Date added 
          array.push(this.moduleJobDetails.actual_start_date);
        }
        if (this.moduleJobDetails.actual_end_date) {
          array.push(this.moduleJobDetails.actual_end_date);
        }
        array.sort((a, b) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
        let fromDate = moment(array[0]);
        let toDate = moment(array[array.length - 1]);

        let dateRange = [];
        while (fromDate <= toDate) {
          let ld = fromDate.format("YYYY-MM-DD");
          let date = {
            date: ld,
          };
          dateRange.push(date);
          fromDate = moment(fromDate).add(1, "days");
        }

        let estimate_date_range = [];
        let estimate_start_date = moment(
          this.moduleJobDetails.estimate_start_date
        );
        let estimate_end_date = moment(this.moduleJobDetails.estimate_end_date);
        while (estimate_start_date <= estimate_end_date) {
          let ld = estimate_start_date.format("YYYY-MM-DD");
          estimate_date_range.push(ld);
          estimate_start_date = moment(estimate_start_date).add(1, "days");
        }

        let actual_start_date = moment(this.moduleJobDetails.actual_start_date);
        let actual_end_date = moment(this.moduleJobDetails.actual_end_date);

        let actual_date_range = [];
        while (actual_start_date <= actual_end_date) {
          let ld = actual_start_date.format("YYYY-MM-DD");
          actual_date_range.push(ld);
          actual_start_date = moment(actual_start_date).add(1, "days");
        }

        dateRange.forEach((date) => {
          date.actual_exists = actual_date_range.some(function (actual_date) {
            return actual_date === date.date;
          });
          date.estimate_exists = estimate_date_range.some(function (
            estimate_date
          ) {
            return estimate_date === date.date;
          });

          if (
            date.estimate_exists == true &&
            moduleJob.actual_start_date == null
          ) {
            date.color = "yellow";
          } else if (
            date.estimate_exists == true &&
            date.actual_exists == false
          ) {
            date.color = "orange";
          } else if (
            date.estimate_exists == true &&
            date.actual_exists == true
          ) {
            date.color = "green";
          } else if (
            date.estimate_exists == false &&
            date.actual_exists == true
          ) {
            date.color = "red";
          } else {
            date.color = "";
          }
        });
        this.moduleJobDetails.dateRange = dateRange;
      }
    },
  },
};
</script>
